module.exports = __webpack_public_path__ + "static/media/menu_reseller.8b800360.svg";